import { useMemo } from 'react';
import { ChoiceDrill } from './ChoiceDrill';
import type { DrillProps } from './meta';
import { makeSjtRound } from './sjt';

export function SjtDrill({ level, seed, onDone }: DrillProps) {
  const questions = useMemo(() => makeSjtRound(level, seed), [level, seed]);
  return (
    <ChoiceDrill
      questions={questions} seed={seed} onDone={onDone} className="sjt-drill" choicesClass="one-col"
      info={(q) => ({ mode: q.mode, situation: q.situation.slice(0, 40) })}
      render={(q) => (
        <div className="lang-q">
          <div className="read-box"><p>{q.situation}</p></div>
          <p className={`lang-ask small-ask ${q.mode === 'worst' ? 'worst' : ''}`}>{q.ask}</p>
        </div>
      )}
      renderChoice={(q, i) => <span className="choice-text">{q.options[i]}</span>}
    />
  );
}
